module.exports = __webpack_public_path__ + "img/link-ok.4c903b74.svg";